import { get } from 'lodash';

export const getPaymentType = payment => {
  if (hasToVerifyMicroDeposits(payment)) return 'bank_account';

  return get(payment, 'source.object', null);
};

export const hasPaymentToPublish = (payment, user) => {
  if (hasToVerifyMicroDeposits(payment)) return true;
  if (user.go4Paid) return true;

  return !!payment && !!payment.source && !!payment.source.id && !!payment.loadedSource;
};

export const hasToVerifyMicroDeposits = payment => {
  return !!Object.keys(payment).includes('publicToken') && !!payment.publicToken;
};

export const getErrorMessage = message => {
  return message.replace(/\(.*?\)/g, '').trim();
};

export const showBlockedFailedPaymentPopups = user => {
  return user.blockedFailedPaymentAt || user.updatedPaymentMethodAt;
};

export const hasPendingFailedPayment = job => {
  return job.lastPaymentAttemptAt && !get(job, 'payment.paidAt');
};

export const blockedByFailedPayment = user => {
  return user.blockedFailedPaymentAt && !user.failedPaymentBlockOverride;
};

export const pendingUnblockFailedPayment = user => {
  return user.updatedPaymentMethodAt && !user.failedPaymentBlockOverride;
};
